import React, { useState } from 'react';
import { auth } from '../firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { Link } from 'react-router-dom';
import { playSound, SOUNDS, vibrate } from '../utils/audio';

const Login = ({ onSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email.trim(), password.trim());
      playSound(SOUNDS.SUCCESS);
      setEmail('');
      setPassword('');
      onSuccess();
    } catch (loginError) {
      setError(loginError.message);
    }
  };

  return (
    <div className="auth-form">
      {error && <p className="error">{error}</p>}
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          required
        />
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          required
        />
        <div className="forgot-password">
          <Link to="/forgot-password">Forgot Password?</Link>
        </div>
        <button type="submit" onClick={() => {
          vibrate(15);
          playSound(SOUNDS.TAP);
        }}>Login</button>
      </form>
    </div>
  );
};

export default Login;
